import endpoints from '@/api/endpoints';
import axios from 'axios';

class API {

    static exportAllCustomers(filters) {
        const url = endpoints.baseURL + endpoints.endpoints.exportAllCustomers;
        return axios.post(url, {
            filters
        }, {
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
            }
        })
    }
    static importClientsFromCsv(clients) {
        const url = endpoints.baseURL + endpoints.endpoints.importFromCsv;
        return axios.post(url, {
            clients
        }, {
            headers: {
                'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
            }
        })
    }

    static sendNow(scenarioId, store) {
        const hideLoader = () => store.commit('ui/hideloader', null, { root: true })
        const url = endpoints.baseURL + API.processUrl(endpoints.endpoints.sendMessagesNow, { scenario_id: scenarioId })
        return axios.post(url, {}, {
            headers: {
                'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
            }
        }).then((result) => {
            hideLoader()
            store.commit('ui/snackbar', {
                display: true,
                label: result.data.payload.message,
                duration: 2500,
                mode: 'success'
            }, { root: true })
        }).catch(() => {
            hideLoader()
            store.commit('ui/snackbar', {
                display: true,
                label: 'Erreur lors de l\'envoie de message',
                duration: 2500,
                mode: 'danger'
            }, { root: true })
        })
    }
    static processUrl(url, parameters) {
        for (var i in parameters) {
            if (parameters.hasOwnProperty(i)) {
                var substring = '{' + i + '}';
                var substring_index = url.indexOf(substring);
                if (substring_index !== -1) {
                    url = url.substring(0, substring_index) + parameters[i] + url.substring(substring_index + substring.length);
                }
            }
        }
        return url;
    }

    static makeGet(url, parameters, withHeaders) {
        if (withHeaders) {
            return axios.get(url, {
                params: parameters,
                headers: {
                    'Accept': 'application/vnd.project.api+json;version=1',
                    'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
                }
            });
        } else if (parameters) {
            return axios.get(url, { params: parameters });
        } else {
            return axios.get(url, {
                headers: {
                    'Accept': 'application/vnd.project.api+json;version=1',
                    'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
                }
            });
        }
    }

    static makePost(url, parameters, withHeaders) {
        if (withHeaders) {
            return axios.post(url, parameters, {
                headers: {
                    'Accept': 'application/vnd.project.api+json;version=1',
                    'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
                }
            });
        } else {
            return axios.post(url, parameters)
        }
    }

    static makePut(url, parameters, withHeaders) {
        if (withHeaders) {
            return axios.put(url, parameters, {
                headers: {
                    'Accept': 'application/vnd.project.api+json;version=1',
                    'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
                }
            });
        } else {
            return axios.put(url, parameters)
        }
    }

    static makeDelete(url, data, withHeaders) {
        if (withHeaders) {
            return axios.delete(url, {
                headers: {
                    'Accept': 'application/vnd.project.api+json;version=1',
                    'Authorization': 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
                },
                data
            });
        } else {
            return axios.delete(url, { data })
        }
    }

    static makeFormDataPost(url, formData, withHeaders) {
        let headers = {
            'Content-Type': 'multipart/form-data'
        };
        if (withHeaders) {
            headers['Accept'] = 'application/vnd.project.api+json;version=1';
            headers['Authorization'] = 'Bearer ' + window.$cookies.get(process.env.VUE_APP_COOKIE_NAME);
        }
        return axios.post(url, formData, { headers: headers });
    }

}
export default API
